/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import Grid from "@mui/material/Grid";
import { format, isValid } from "date-fns";
import get from "lodash/get";
import * as Yup from "yup";

import { getStakeholders } from "../../../../../store/selectors/stakeholders";
import {
  getSignatories,
  getFreeFieldsInfo,
  getROSignatories
} from "../../../../../store/selectors/appConfig";
import { getCompletedSteps } from "../../../../../store/selectors/completedSteps";
import {
  updateProspect,
  loadMetaData,
  updateRoProspect
} from "../../../../../store/actions/appConfig";
import { getRequiredMessage } from "../../../../../utils/getValidationMessage";
import { COMPANY_STAKEHOLDER_ID } from "../../../../../containers/PostEligibilityCompanyStakeholders/constants";
import {
  PRE_ELIGIBILITY_COMPANY_STAKEHOLDER_ID,
  STEP_6
} from "../../../../../containers/CompanyStakeholders/constants";
import {
  AutoSaveField as Field,
  DatePicker,
  Input,
  SelectAutocomplete,
  InlineRadioGroup
} from "../../../../../components/Form";
import { DATE_FORMAT, STEP_STATUS } from "../../../../../constants";

import { SubmitButton } from "../../../components/SubmitButton/SubmitButton";
import { YesNoList } from "../../../../../constants/options";
import { cloneDeep } from "../../../../../utils/cloneDeep";
import { ScrollToError } from "components/ScrollToError";

const initialValues = (companyInfo, lineofBusinessValue, genderValue, isGuarantorsStatus) => {
  return {
    dateOfIncorporation: companyInfo.yearOfTLIssued,
    lineofBusiness: lineofBusinessValue,
    gender: genderValue,
    guarantorsStatus: isGuarantorsStatus
  };
};

const shareholderSchema = isShareholderACompany =>
  Yup.object().shape({
    gender: Yup.string().when("isShareholderACompany", {
      is: value => !isShareholderACompany,
      then: Yup.string() // NOSONAR
        .nullable()
        .required(getRequiredMessage("Gender"))
    }),
    lineofBusiness: Yup.string()
      .nullable()
      .max(20, "Maximum 20 characters allowed"),
    guarantorsStatus: Yup.string()
      .nullable()
      .required(getRequiredMessage("Guarantor status")),
    dateOfIncorporation: Yup.string().when("isShareholderACompany", {
      is: value => isShareholderACompany,
      then: Yup.string() // NOSONAR
        .nullable()
        .required(getRequiredMessage("Date of Incorporation"))
    })
  });
const StakeholderInfoComponent = ({
  handleContinue,
  index,
  stakeholders,
  isShareholderACompany,
  createFormChangeHandler,
  freeFieldsInfo,
  completedSteps,
  updateProspect,
  dateOfIncorporationValue,
  updateRoProspect,
  loadMetaData,
  isGuarantorsStatus,
  genderValue,
  lineofBusinessValue
}) => {
  const stakeholderId = stakeholders[index] && stakeholders[index].id ? stakeholders[index].id : "";
  const companyInfo = stakeholders[index].signatoryCompanyInfo;
  const stakeholderASignatory =
    stakeholders[index] && stakeholders[index].isSignatory ? stakeholders[index].isSignatory : "";
  const changeDateProspectHandler = (_, value, path) =>
    isValid(value) && { [path]: format(value, DATE_FORMAT) };
  const signatoryPath = `roProspect.signatoryInfo[${index}]`;
  const stakeholderRef = useRef(isGuarantorsStatus);
  const formInfoRef = useRef();
  useEffect(() => {
    if (stakeholderRef.current !== isGuarantorsStatus) {
      stakeholderRef.current = isGuarantorsStatus;
      if (isGuarantorsStatus === "Yes" && !stakeholderASignatory) {
        const clonedCompletedSteps = cloneDeep(completedSteps);
        const newCompletedSteps = clonedCompletedSteps.map(completedStep => {
          if (
            completedStep.flowId === `${COMPANY_STAKEHOLDER_ID}${stakeholderId}` ||
            (completedStep.flowId === `${PRE_ELIGIBILITY_COMPANY_STAKEHOLDER_ID}${stakeholderId}` &&
              completedStep.step === STEP_6)
          ) {
            return { ...completedStep, status: STEP_STATUS.RESET };
          }
          return completedStep;
        });
        const completedStepsStr = JSON.stringify({
          completedSteps: newCompletedSteps
        });
        freeFieldsInfo.freeField5 = completedStepsStr;
        updateProspect({
          "prospect.freeFieldsInfo.freeField5": completedStepsStr
        });
        loadMetaData(freeFieldsInfo);
      }
    }
  }, [isGuarantorsStatus]);
  useEffect(() => {
    if (isShareholderACompany) {
      formInfoRef.current.setFieldValue("dateOfIncorporation", companyInfo.yearOfTLIssued);
      updateRoProspect({
        [`roProspect.signatoryInfo[${index}].signatoryCompanyInfo.dateOfIncorporation`]: companyInfo.yearOfTLIssued
      });
    }
  }, [companyInfo.yearOfTLIssued]);

  return (
    <Formik
      innerRef={formInfoRef}
      enableReinitialize={true}
      initialValues={initialValues(
        companyInfo,
        lineofBusinessValue,
        genderValue,
        isGuarantorsStatus
      )}
      onSubmit={handleContinue}
      validateOnChange={false}
      validationSchema={shareholderSchema(isShareholderACompany)}
    >
      {createFormChangeHandler(({ values, setFieldValue }) => {
        return (
          <Form>
            <ScrollToError />
            <Grid container spacing={3}>
              {isShareholderACompany ? (
                <>
                  <Grid item sm={12} xs={12}>
                    <h5> Stakeholder is a Company </h5>
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <Field
                      name="dateOfIncorporation"
                      label="Date of incorporation"
                      path={`${signatoryPath}.signatoryCompanyInfo.dateOfIncorporation`}
                      disabled={true}
                      component={DatePicker}
                      onChange={value => {
                        setFieldValue("dateOfIncorporation", value);
                      }}
                      changeProspect={changeDateProspectHandler}
                      InputProps={{
                        inputProps: { tabIndex: 0 }
                      }}
                      maxDate={new Date()}
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <Field
                      name="lineofBusiness"
                      label="Line of Business"
                      path={`${signatoryPath}.signatoryCompanyInfo.lineofBusiness`}
                      component={Input}
                      tabIndex="0"
                      InputProps={{
                        inputProps: { tabIndex: 0 }
                      }}
                    />
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item sm={12} xs={12}>
                    <h5> Stakeholder is an Individual</h5>
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <Field
                      name="gender"
                      label="Gender"
                      placeholder="Gender"
                      path={`${signatoryPath}.gender`}
                      component={SelectAutocomplete}
                      datalistId="gender"
                      tabIndex="0"
                      isSearchable
                    />
                  </Grid>
                </>
              )}
              <Grid item sm={9} xs={12} mt={1}>
                <Field
                  name="guarantorsStatus"
                  component={InlineRadioGroup}
                  path={`${signatoryPath}.guarantorsStatus`}
                  options={YesNoList}
                  label="Guarantors status"
                  InputProps={{
                    inputProps: { tabIndex: 0 }
                  }}
                />
              </Grid>
            </Grid>
            <SubmitButton />
          </Form>
        );
      })}
    </Formik>
  );
};

const mapStateToProps = (state, { index }) => ({
  stakeholders: getStakeholders(state),
  isShareholderACompany: get(getSignatories(state)[index], "isShareholderACompany", ""),
  completedSteps: getCompletedSteps(state),
  freeFieldsInfo: getFreeFieldsInfo(state),
  isGuarantorsStatus: get(getROSignatories(state)[index], "guarantorsStatus", "No"),
  genderValue: get(getROSignatories(state)[index], "gender", ""),
  lineofBusinessValue: get(getROSignatories(state)[index], "lineofBusiness", ""),
  dateOfIncorporationValue: get(
    getROSignatories(state)[index],
    "signatoryCompanyInfo.dateOfIncorporation",
    ""
  )
});

const mapDispatchToProps = {
  updateProspect,
  updateRoProspect,
  loadMetaData
};

export const StakeholderInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(StakeholderInfoComponent);
